module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M30 0H2C.894 0 0 .894 0 2v28c0 1.106.894 2 2 2h28c1.106 0 2-.894 2-2V2c0-1.106-.894-2-2-2zm-7.636 19.536a1 1 0 0 1 0 1.414l-1.414 1.414a1 1 0 0 1-1.414 0L16 18.828l-3.536 3.536a1 1 0 0 1-1.414 0L9.636 20.95a1 1 0 0 1 0-1.414L13.172 16l-3.536-3.536a1 1 0 0 1 0-1.414l1.414-1.414a1 1 0 0 1 1.414 0L16 13.172l3.536-3.536a1 1 0 0 1 1.414 0l1.414 1.414a1 1 0 0 1 0 1.414L18.828 16l3.536 3.536z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/x-3.js
// module id = 1507
// module chunks = 14